// 트리 구조 빌드
export const buildTree = (list) => {
  const map = {};
  const roots = [];

  list.forEach((item) => {
    map[item.MENU_ID] = { ...item, children: [] };
  });

  list.forEach((item) => {
    const { MENU_ID, HIPO_MENU_ID } = item;

    if (!HIPO_MENU_ID || HIPO_MENU_ID === MENU_ID || !map[HIPO_MENU_ID]) {
      roots.push(map[MENU_ID]);
    } else {
      map[HIPO_MENU_ID].children.push(map[MENU_ID]);
    }
  });

  return roots;
};
